import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

import { AdminUserSchema } from './admin';

// ============================================================================
// PROF DASHBOARD TYPES
// ============================================================================
// Kept separate from admin.ts's admin-tool schemas (GetUsersQuerySchema /
// GetUsersResponseSchema, used only by the is_admin-only /admin/users route)
// so the two routes' schemas can evolve independently. GET /prof-dashboard/
// students always returns STUDENT accounts only (enforced server-side), so
// there's no role/is_admin filter here. The user row shape itself (AdminUserSchema)
// is still shared - it's the same underlying User representation either way.

export const GetStudentsQuerySchema = Type.Object({
  page: Type.Optional(Type.Number({ minimum: 1 })),
  limit: Type.Optional(Type.Number({ minimum: 1, maximum: 100 })),
  search: Type.Optional(Type.String()),
  sort_by: Type.Optional(
    Type.Union([
      Type.Literal('created_at'),
      Type.Literal('username'),
      Type.Literal('email_address'),
      Type.Literal('scan_credit'),
    ])
  ),
  sort_order: Type.Optional(
    Type.Union([Type.Literal('asc'), Type.Literal('desc')])
  ),
});
export type GetStudentsQuery = Static<typeof GetStudentsQuerySchema>;

export const GetStudentsResponseSchema = Type.Object({
  data: Type.Object({
    users: Type.Array(AdminUserSchema),
    total: Type.Number(),
    page: Type.Number(),
    limit: Type.Number(),
  }),
});
export type GetStudentsResponse = Static<typeof GetStudentsResponseSchema>;
